import { navigateAction } from 'fluxible-router';
import { setJWTToken, setNetwork, setSpotId, setToken } from 'app/scripts/services/app-state';
import { initializeAppStart, TDispatch, updateAppState } from 'state';
import fetchCurrentUser from 'app/scripts/components/account/state/actions/current-user';
import * as context from 'state/fluxible-context';
import me from 'fed-resources/resources/me';
import logoutAccount from '../../../actions/account/logout';
import { syncSpotsToRedux } from 'state/helpers/syncHelpers';

const initializeApp = payload => {
  return async (dispatch: TDispatch) => {
    const { network, token, spotId } = payload;
    const accessToken = window.localStorage?.getItem('SPOTIM_ACCESS_TOKEN');
    const hasTokens = accessToken || token;

    dispatch(initializeAppStart(payload));

    setJWTToken(accessToken);
    setNetwork(network);
    setSpotId(spotId);
    setToken(token);

    if (!spotId) {
      return;
    }

    if (!hasTokens) {
      await redirectToLoginPage(network);
      return;
    }

    try {
      dispatch(updateAppState({ token, accessToken }));

      const currentUserData = await dispatch(fetchCurrentUser());
      const { body } = await me.getMyMultiSpots();

      syncSpotsToRedux(body);

      if (!currentUserData.registered) {
        context.executeAction(logoutAccount, { spotId });
      }
    } catch (error) {
      console.error(error);
      await redirectToLoginPage(network);
    }
  };
};

function redirectToLoginPage(network) {
  return context.executeAction(navigateAction, {
    url: `/network/${network.network_name}`
  });
}

export default initializeApp;
